(() => {
  const headingText = "you may also like";
  const mediaBackground = "#f4f7f9";
  const textBackground = "#07101a";
  const cardSelector = ".product-card-wrapper, .card-wrapper, .card";
  const mediaSelector = ".card__inner, .card__media, .media, .media--transparent";

  function findSectionFromHeading() {
    const headings = Array.from(document.querySelectorAll("h1,h2,h3,h4,p,span,div"))
      .filter((el) => (el.textContent || "").trim().toLowerCase() === headingText);

    for (const heading of headings) {
      let node = heading;
      for (let depth = 0; node && depth < 8; depth += 1, node = node.parentElement) {
        if (node.querySelectorAll && node.querySelectorAll(cardSelector).length >= 2) return node;
      }
    }

    return Array.from(document.querySelectorAll("section, product-recommendations, .shopify-section, div"))
      .filter((el) => (el.innerText || "").toLowerCase().includes(headingText))
      .sort((a, b) => a.querySelectorAll(cardSelector).length - b.querySelectorAll(cardSelector).length)
      .find((el) => el.querySelectorAll(cardSelector).length >= 2);
  }

  function applyFix() {
    const section = findSectionFromHeading();
    if (!section) return;
    section.classList.add("dr-related-products-visibility-fixed");

    section.querySelectorAll(mediaSelector).forEach((el) => {
      el.style.setProperty("background", mediaBackground, "important");
      el.style.setProperty("background-color", mediaBackground, "important");
      el.style.setProperty("background-image", "none", "important");
      el.style.setProperty("opacity", "1", "important");
      el.style.setProperty("filter", "none", "important");
      el.style.setProperty("mix-blend-mode", "normal", "important");
      el.style.setProperty("visibility", "visible", "important");
    });

    section.querySelectorAll(".product-card-wrapper .card, .card-wrapper .card").forEach((card) => {
      const innerContent = card.querySelector(":scope > .card__inner > .card__content");
      const outerContent = Array.from(card.children).find((element) => element.classList.contains("card__content"));

      if (innerContent) {
        innerContent.style.removeProperty("background");
        innerContent.style.removeProperty("background-color");
        innerContent.style.removeProperty("background-image");
        innerContent.style.setProperty("background", "transparent", "important");
        innerContent.style.setProperty("background-color", "transparent", "important");
        innerContent.style.setProperty("pointer-events", "none", "important");
      }

      if (outerContent) {
        outerContent.style.setProperty("background", textBackground, "important");
        outerContent.style.setProperty("background-color", textBackground, "important");
      }
    });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", applyFix);
  else applyFix();
  window.setTimeout(applyFix, 250);
  window.setTimeout(applyFix, 1000);
  document.addEventListener("shopify:section:load", applyFix);
})();
